import { EXPRESS_API } from 'configs/api/expressApi';

export const getCodirectUrl = async () => {
  const response = await EXPRESS_API.get('/amms/get-codirect-url');
  return response.data;
};
